var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"conf"},[_c('h1',{staticClass:"tms-title"},[_vm._v("CONFIGURATION")]),_c('ConfigurationDivisions'),_c('ConfigurationSSL'),_c('ConfigurationPool'),_c('ConfigurationSize'),_c('ConfigurationType'),_c('GpsSetting')],1)}
var staticRenderFns = []

export { render, staticRenderFns }